import { render, staticRenderFns } from "./CampusUpload.vue?vue&type=template&id=fc92b9e6&"
import script from "./CampusUpload.vue?vue&type=script&lang=ts&"
export * from "./CampusUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports